// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import { KTIcon } from '../../../../../../_metronic/helpers'
// // UnitMeasurementModalForm
// // import UnitMeasurementModalForm from '../form-edit-modal/FacilitiesModalForm'
// import WCC from '../form-edit-modal/WCC'
// import { KTCard } from '../../../../../../_metronic/helpers'
// import SustainabilityDeclarationForm from './test'


// interface ApiData {
//   overallTotalDue: number
//   overallTotalPaid: number
//   overallTotalBalance: number
//   overallTotalSupplied: number
//   userRewardDetails: User[]
// }

// interface ApiResponse {
//   data: ApiData
//   meta: {
//     pageSize: number
//     currentPage: number
//   }
//   totalStock: number
// }

// interface User {
//   userId: string
//   userProfile: string
//   userName: string
//   totalDue: number
//   totalBalance: number
//   totalPaid: number
//   totalSupplied: number
//   transactions: any[]
// }


// const IsccWasteCollectorPaymentList = () => {

//   const [showAddModal, setShowAddModal] = useState(false)
//   const [users, setUsers] = useState<ApiData | null>(null)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState('')
//   const [searchQuery, setSearchQuery] = useState('')
//   const [filteredUsers, setFilteredUsers] = useState<User[]>([])

//   const [showModal, setShowModal] = useState(false)
//   const [selectedUser, setSelectedUser] = useState<User | null>(null)
//   const handleEditClick = (user: User) => {
//     setSelectedUser(user)
//     setShowModal(true)
//   }

//   // Fetch data from API
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true)
//         const response = await axios.get<ApiResponse>(
//           `${process.env.REACT_APP_BASE_API_URL}user/due?type=66e7e51350f6c726a2bb6b55`,
//           {
//             headers: {
//               'accept': 'application/json',
//               'app-id': '3',
//               'client-id': '101212',
//             }
//           }
//         )

//         const userData = response.data.data || { userRewardDetails: [] }
//         setUsers(userData)
//         setFilteredUsers(userData.userRewardDetails)
//         setLoading(false)
//       } catch (err) {
//         console.error('API Error:', err)
//         setError('Failed to fetch data')
//         setLoading(false)
//       }
//     }

//     fetchData()
//   }, [])



//   console.log("user data ...........", users)


//   useEffect(() => {
//     if (!users) return

//     if (searchQuery === '') {
//       setFilteredUsers(users.userRewardDetails)
//     } else {
//       const filtered = users.userRewardDetails.filter(user =>
//         user.userName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         user.userId?.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//       setFilteredUsers(filtered)
//     }
//   }, [searchQuery, users])

//   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchQuery(e.target.value)
//   }

//   if (loading) {
//     return (
//       <div style={{ padding: '20px', textAlign: 'center' }}>
//         <div>Loading...</div>
//       </div>
//     )
//   }

//   if (error) {
//     return (
//       <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
//         <div>{error}</div>
//       </div>
//     )
//   }

//   return (
//     <KTCard>
//       <div style={{ padding: '20px' }}>
//         {/* Search Box */}
//         <div style={{ marginBottom: '20px', position: 'relative', width: '300px' }}>
//           <svg
//             width="16"
//             height="16"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             style={{
//               position: 'absolute',
//               left: '10px',
//               top: '50%',
//               transform: 'translateY(-50%)',
//               color: '#6B7280',
//             }}
//           >
//             <circle cx="11" cy="11" r="8" />
//             <line x1="21" y1="21" x2="16.65" y2="16.65" />
//           </svg>
//           <input
//             type="text"
//             placeholder="Search users..."
//             value={searchQuery}
//             onChange={handleSearch}
//             style={{
//               width: '100%',
//               height: '40px',
//               padding: '8px 8px 8px 35px',
//               fontSize: '14px',
//               border: '1px solid #E5E7EB',
//               borderRadius: '6px',
//               outline: 'none',
//               backgroundColor: 'white',
//             }}
//           />
//         </div>

//         <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>



//           <div style={{
//             margin: '10px',
//             padding: '16px',
//             borderRadius: '8px',
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             backgroundColor: '#ffffff',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'start', // ✅ center horizontally
//             flex: 1
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',        // ✅ center vertically inside this row
//               justifyContent: 'center'
//             }}>
//               <div style={{
//                 width: '48px',
//                 height: '48px',
//                 borderRadius: '50%',
//                 backgroundColor: '#dff5eb',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 marginRight: '16px',
//                 fontSize: '20px',
//                 fontWeight: 'bold',
//                 color: '#1a1a1a'
//               }}>
//                 <img src="/media/svg/dashboard/New/recycling capacity.png" alt="" style={{ width: '27px', height: '27px' }}></img>
//               </div>

//               <div style={{ textAlign: 'left' }}>
//                 <div style={{ fontSize: '16px', fontWeight: '400' }}>Material Supplied</div>
//                 <div style={{ fontSize: '24px', fontWeight: '700' }}>
//                   {/* {supplierLedgerList.totalSupplied ?? ''} */}
//                   {/* {(supplierLedgerList?.[0]?.totalSupplied ?? 0).toFixed(2)} */}
//                   {(users?.overallTotalSupplied || 0).toFixed(2)}
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div style={{
//             margin: '10px',
//             padding: '16px',
//             borderRadius: '8px',
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             backgroundColor: '#ffffff',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'start', // ✅ center horizontally
//             flex: 1
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',        // ✅ center vertically inside this row
//               justifyContent: 'center'
//             }}>
//               <div style={{
//                 width: '48px',
//                 height: '48px',
//                 borderRadius: '50%',
//                 backgroundColor: '#c8f0e8',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 marginRight: '16px',
//                 fontSize: '20px',
//                 fontWeight: 'bold',
//                 color: '#1a1a1a'
//               }}>
//                 <img src="/media/svg/dashboard/New/total value.png" alt="" style={{ width: '27px', height: '27px' }}></img>
//               </div>

//               <div style={{ textAlign: 'left' }}>
//                 <div style={{ fontSize: '16px', fontWeight: '400' }}>Total Value</div>
//                 <div style={{ fontSize: '24px', fontWeight: '700' }}>
//                   {/* {supplierLedgerList.totalDue ?? ''} */}
//                   {/* {(supplierLedgerList?.[0]?.totalDue ?? 0).toFixed(2)} */}
//                   {(users?.overallTotalDue || 0).toFixed(2)}
//                 </div>
//               </div>
//             </div>
//           </div>



//           <div style={{
//             margin: '10px',
//             padding: '16px',
//             borderRadius: '8px',
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             backgroundColor: '#ffffff',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'start', // ✅ center horizontally
//             flex: 1
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',        // ✅ center vertically inside this row
//               justifyContent: 'center'
//             }}>
//               <div style={{
//                 width: '48px',
//                 height: '48px',
//                 borderRadius: '50%',
//                 backgroundColor: '#e4d9f2',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 marginRight: '16px',
//                 fontSize: '20px',
//                 fontWeight: 'bold',
//                 color: '#1a1a1a'
//               }}>
//                 <img src="/media/svg/dashboard/New/Total paid.png" alt="" style={{ width: '27px', height: '27px' }}></img>
//               </div>

//               <div style={{ textAlign: 'left' }}>
//                 <div style={{ fontSize: '16px', fontWeight: '400' }}>Total Payment</div>
//                 <div style={{ fontSize: '24px', fontWeight: '700' }}>
//                   {/* {supplierLedgerList.totalPaid ?? ''} */}
//                   {/* {(supplierLedgerList?.[0]?.totalPaid ?? 0).toFixed(2)} */}
//                   {(users?.overallTotalPaid || 0).toFixed(2)}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div style={{
//             margin: '10px',
//             padding: '16px',
//             borderRadius: '8px',
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             backgroundColor: '#ffffff',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'start', // ✅ center horizontally
//             flex: 1
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',        // ✅ center vertically inside this row
//               justifyContent: 'center'
//             }}>
//               <div style={{
//                 width: '48px',
//                 height: '48px',
//                 borderRadius: '50%',
//                 backgroundColor: '#f7f5c5',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 marginRight: '16px',
//                 fontSize: '20px',
//                 fontWeight: 'bold',
//                 color: '#1a1a1a'
//               }}>

//                 <img src="/media/svg/dashboard/New/Pending Payment.png" alt="" style={{ width: '27px', height: '27px' }}></img>

//               </div>

//               <div style={{ textAlign: 'left' }}>
//                 <div style={{ fontSize: '16px', fontWeight: '400' }}>Closing Balance</div>
//                 <div style={{ fontSize: '24px', fontWeight: '700' }}>
//                   {/* {supplierLedgerList.totalBalance ?? ''} */}
//                   {/* {(supplierLedgerList?.[0]?.totalBalance ?? 0).toFixed(2)} */}
//                   {(users?.overallTotalBalance || 0).toFixed(2)}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>


//         {/* Table */}
//         <div style={{ overflowX: 'auto' }}>


//           {/* 
//           <button
//             onClick={() => setShowAddModal(true)}
//             style={{
//               backgroundColor: '#007bff',
//               color: 'white',
//               border: 'none',
//               padding: '10px 15px',
//               borderRadius: '5px',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '5px'
//             }}
//           >
//             <span>+</span>
//             Add New
//           </button> */}


//           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead>
//               <tr style={{ backgroundColor: '#333333', color: 'white' }}>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>S.N</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>PROFILE</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>NAME</th>
//                 {/* <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>UNIQUE ID</th> */}
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>SUPPLIED QTY</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>VALUE</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>PAID</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>PAYMENT DUE</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>ACTIONS</th>
//               </tr>
//             </thead>
//             <tbody>
//               {users && users.userRewardDetails.length > 0 ? (
//                 users.userRewardDetails.map((user, index) => (
//                   <tr
//                     key={user.userId}
//                     style={{
//                       backgroundColor: 'white'
//                     }}
//                   >
//                     <td style={{ padding: '12px' }}>{index + 1}</td>
//                     <td style={{ padding: '12px' }}>
//                       {user.userProfile ? (
//                         <img
//                           src={user.userProfile}
//                           alt="Profile"
//                           style={{
//                             width: '50px',
//                             height: '50px',
//                             borderRadius: '50%',
//                             objectFit: 'cover',
//                             // border: '2px solid #e2e8f0'
//                           }}
//                           onError={(e) => {
//                             const target = e.target as HTMLImageElement
//                             target.style.display = 'none'
//                             // target.nextElementSibling!.style.display = 'flex'
//                           }}
//                         />
//                       ) : null}
//                       <div
//                         style={{
//                           width: '50px',   
//                           height: '50px',  
//                           borderRadius: '50%',
//                           backgroundColor: '#333333',
//                           display: user.userProfile ? 'none' : 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           fontSize: '15px',
//                           color: '#64748b',
//                           // fontWeight: 'bold'
//                         }}
//                       >
//                         {user.userName ? user.userName.substring(0, 2).toUpperCase() : 'NA'}
//                       </div>
//                     </td>
//                     <td style={{ padding: '12px', fontWeight: '500' }}>
//                       {user.userName || 'N/A'}
//                     </td>
//                     {/* <td style={{ padding: '12px', fontSize: '12px', color: '#64748b' }}>
//                     {user.userId?.substring(0, 8)}...
//                   </td> */}
//                     <td style={{ padding: '12px' }}>
//                       {user.totalSupplied?.toFixed(2) || '0.00'}
//                     </td>
//                     <td style={{ padding: '12px' }}>
//                       {user.totalDue?.toLocaleString() || '0'}
//                     </td>
//                     <td>
//                       <span style={{
//                         padding: '5px',
//                         fontWeight: '600',
//                         color: '#17c653',
//                         backgroundColor: '#dfffea',
//                         borderRadius: '8px'
//                       }}>
//                         {user.totalPaid?.toLocaleString() || '0'}</span>
//                     </td>
//                     <td>
//                       <span style={{
//                         padding: '5px',
//                         fontWeight: '600',
//                         color: '#f8285a',
//                         backgroundColor: '#ffeef3',
//                         borderRadius: '8px'
//                       }}>
//                         {user.totalBalance?.toLocaleString() || '0'}</span>
//                     </td>
//                     <td style={{ padding: '12px' }}>
//                       <div style={{ cursor: 'pointer' }} onClick={() => handleEditClick(user)}>
//                         <KTIcon iconName='pencil' className='fs-3' />
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan={9}
//                     style={{
//                       padding: '40px',
//                       textAlign: 'center',
//                       color: '#9ca3af',
//                       fontSize: '16px'
//                     }}
//                   >
//                     No matching records found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//         {/* Add this before the closing </div> */}
//         {/* Custom Modal */}
//         {showModal && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1000
//             }}
//             onClick={() => setShowModal(false)}
//           >
//             <div
//               style={{
//                 backgroundColor: 'white',
//                 padding: '20px',
//                 borderRadius: '8px',
//                 maxWidth: '800px',
//                 width: '90%',
//                 maxHeight: '80vh',
//                 overflowY: 'auto'
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                 <h3>Edit user</h3>
//                 <button
//                   onClick={() => setShowModal(false)}
//                   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
//                 >
//                   ×
//                 </button>
//               </div>

//               <WCC
//                 isUserLoading={false}
//                 user={selectedUser}
//                 onClose={() => setShowModal(false)}
//               />
//             </div>
//           </div>
//         )}



//         {/* Add New Modal */}
//         {showAddModal && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1000
//             }}
//             onClick={() => setShowAddModal(false)}
//           >
//             <div
//               style={{
//                 backgroundColor: 'white',
//                 padding: '20px',
//                 borderRadius: '8px',
//                 maxWidth: '900px',
//                 width: '90%',
//                 maxHeight: '100vh',
//                 overflowY: 'auto'
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                 <h3></h3>
//                 <button
//                   onClick={() => setShowAddModal(false)}
//                   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
//                 >
//                   ×
//                 </button>
//               </div>

//               {/* Replace YourNewComponent with your actual component */}
//               <SustainabilityDeclarationForm
//                 onClose={() => setShowAddModal(false)}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </KTCard>
//   )
// }

// export { IsccWasteCollectorPaymentList }










// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import { KTIcon } from '../../../../../../_metronic/helpers'
// // UnitMeasurementModalForm
// // import UnitMeasurementModalForm from '../form-edit-modal/FacilitiesModalForm'
// import WCC from '../form-edit-modal/WCC'
// import { KTCard } from '../../../../../../_metronic/helpers'
// import SustainabilityDeclarationForm from './test'

// interface User {
//   userId: string
//   userProfile: string
//   userName: string
//   totalDue: number
//   totalBalance: number
//   totalPaid: number
//   totalSupplied: number
//   transactions: any[]
//   date: string
//   recipientInfo: {
//     name: string
//     // add other recipient properties as needed
//   }
//   quantity: number
//   countryOfOrigin: string
//   productName: string
//   actualSupplyDate: string
//   uniqueNo: string
//   centreInfo?: {
//     name: string
//   }
//   pickupPointName?: string
//   orderDetails?: {
//     categoryName?: string
//     items?: {
//       itemName: string
//       quantity: number
//     }[]
//   }[]
//   isccEu?: {
//     eec?: { value: number; type: string }
//     el?: { value: number; type: string }
//     esca?: { value: number; type: string }
//     methaneCredit?: { value: number; type: string }
//     lhv?: { value: number; type: string }
//     etdCollect?: { value: number; type: string }
//     etdReturn?: { value: number | null; type: string | null }
//     etdConvert?: { value: number | null; type: string | null }
//   }
// }

// interface ApiResponse {
//   data: User[]
//   meta: {
//     pageSize: number
//     currentPage: number
//   }
//   totalStock: number
// }

// const IsccWasteCollectorPaymentList = () => {

//   const [showAddModal, setShowAddModal] = useState(false)
//   const [users, setUsers] = useState<User[]>([])
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState('')
//   const [searchQuery, setSearchQuery] = useState('')
//   const [filteredUsers, setFilteredUsers] = useState<User[]>([])

//   const [showModal, setShowModal] = useState(false)
//   const [selectedUser, setSelectedUser] = useState<User | null>(null)
//   const handleEditClick = (user: User) => {
//     setSelectedUser(user)
//     setShowModal(true)
//   }

//   // Fetch data from API
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true)
//         const response = await axios.get<ApiResponse>(
//           `${process.env.REACT_APP_BASE_API_URL}return/orders?status=COMPLETED&page=0&size=10`,
//           {
//             headers: {
//               'accept': 'application/json',
//               'app-id': '3',
//               'client-id': '101212',
//             }
//           }
//         )

//         const userData = response.data.data || []
//         setUsers(userData)
//         setFilteredUsers(userData)
//         setLoading(false)
//       } catch (err) {
//         console.error('API Error:', err)
//         setError('Failed to fetch data')
//         setLoading(false)
//       }
//     }

//     fetchData()
//   }, [])

//   // Handle search
//   useEffect(() => {
//     if (searchQuery === '') {
//       setFilteredUsers(users)
//     } else {
//       const filtered = users.filter(user =>
//         user.userName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         user.userId?.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//       setFilteredUsers(filtered)
//     }
//   }, [searchQuery, users])

//   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchQuery(e.target.value)
//   }

//   if (loading) {
//     return (
//       <div style={{ padding: '20px', textAlign: 'center' }}>
//         <div>Loading...</div>
//       </div>
//     )
//   }

//   return (
//     <KTCard>
//       <div style={{ padding: '20px' }}>
//         {/* Search Box */}
//         <div style={{
//           marginBottom: '20px',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center'
//         }}>
//           <div style={{ position: 'relative', width: '300px' }}>
//             <svg
//               width="16"
//               height="16"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               style={{
//                 position: 'absolute',
//                 left: '10px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 color: '#6B7280',
//               }}
//             >
//               <circle cx="11" cy="11" r="8" />
//               <line x1="21" y1="21" x2="16.65" y2="16.65" />
//             </svg>
//             <input
//               type="text"
//               placeholder="Search users..."
//               value={searchQuery}
//               onChange={handleSearch}
//               style={{
//                 width: '100%',
//                 height: '40px',
//                 padding: '8px 8px 8px 35px',
//                 fontSize: '14px',
//                 border: '1px solid #E5E7EB',
//                 borderRadius: '6px',
//                 outline: 'none',
//                 backgroundColor: 'white',
//               }}
//             />
//           </div>
//           {/* <button
//             onClick={() => setShowAddModal(true)}
//             style={{ backgroundColor: "#12b886", }}
//             className="btn btn-primary"
//           >
//             <span>+ </span>
//             Add New
//           </button> */}
//         </div>

//         {/* Table */}
//         <div style={{ overflowX: 'auto' }}>






//           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead>
//               <tr style={{ backgroundColor: '#333333', color: 'white' }}>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>S.N</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>DATE</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>SUPPLIER</th>
//                 {/* <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>UNIQUE ID</th> */}
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>PRODUCT NAME</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>CATEGORY</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>QUANTITY</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>GHG VALUE</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>RECIPIENT</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>SD STATUS</th>
//                 <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>VIEW</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredUsers.length > 0 ? (
//                 filteredUsers.map((user, index) => (
//                   <tr
//                     key={user.userId}
//                     style={{
//                       backgroundColor: 'white'
//                     }}
//                   >
//                     <td style={{ padding: '12px', fontSize: '13px' }}>{index + 1}</td>
//                     <td style={{ padding: '12px', fontSize: '13px' }}>
//                       {user.actualSupplyDate ? new Date(user.actualSupplyDate).toLocaleDateString('en-CA').replace(/-/g, '/') : 'N/A'}
//                     </td>
//                     <td style={{ padding: '12px', fontWeight: '500', fontSize: '13px' }}>
//                       {user?.pickupPointName}
//                     </td>
//                     <td style={{ padding: '12px', fontSize: '13px' }}>
//                       {user.orderDetails?.[0]?.items?.[0]?.itemName}
//                     </td>
//                     <td style={{ padding: '12px', fontSize: '13px' }}>
//                       {user.orderDetails?.[0]?.categoryName}
//                     </td>
//                     <td style={{ padding: '12px', fontSize: '13px' }}>
//                       {user.orderDetails?.[0]?.items?.[0]?.quantity}
//                     </td>
//                     <td>
//                       <td className={`badge badge-light-info fs-7 fw-bold`}>
//                         {(
//                           (user.isccEu?.eec?.value ?? 0) +
//                           (user.isccEu?.el?.value ?? 0) +
//                           (user.isccEu?.esca?.value ?? 0) +
//                           (user.isccEu?.methaneCredit?.value ?? 0) +
//                           (user.isccEu?.etdCollect?.value ?? 0) +
//                           (user.isccEu?.etdReturn?.value ?? 0) +
//                           (user.isccEu?.etdConvert?.value ?? 0)
//                         ).toFixed(2)}
//                       </td>

//                     </td>
//                     <td style={{ padding: '12px', fontSize: '13px' }}>
//                       <div style={{ cursor: 'pointer' }} onClick={() => handleEditClick(user)}>
//                         {user.centreInfo?.name || 'N/A'}
//                       </div>
//                     </td>
//                     <td style={{ padding: '12px', fontSize: '13px' }}>
//                       <div
//                         style={{
//                           cursor: 'pointer',
//                           backgroundColor: '#defee9',
//                           color: '#17c653',
//                           fontWeight: 'bold',
//                           borderRadius: '6px',
//                           padding: '2px 2px',
//                           textAlign: 'center',
//                           display: 'inline-block',
//                           minWidth: '80px',
//                           fontSize: "12px"
//                         }}
//                         onClick={() => handleEditClick(user)}
//                       >
//                         RECEIVED
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan={9}
//                     style={{
//                       padding: '40px',
//                       textAlign: 'center',
//                       color: '#9ca3af',
//                       fontSize: '14px'
//                     }}
//                   >
//                     No matching records found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//         {/* Add this before the closing </div> */}
//         {/* Custom Modal */}
//         {showModal && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1000
//             }}
//             onClick={() => setShowModal(false)}
//           >
//             <div
//               style={{
//                 backgroundColor: 'white',
//                 padding: '20px',
//                 borderRadius: '8px',
//                 maxWidth: '800px',
//                 width: '90%',
//                 maxHeight: '80vh',
//                 overflowY: 'auto'
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                 <h3>Edit user</h3>
//                 <button
//                   onClick={() => setShowModal(false)}
//                   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
//                 >
//                   ×
//                 </button>
//               </div>

//               <WCC
//                 isUserLoading={false}
//                 user={selectedUser}
//                 onClose={() => setShowModal(false)}
//               />
//             </div>
//           </div>
//         )}



//         {/* Add New Modal */}
//         {showAddModal && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1000
//             }}
//             onClick={() => setShowAddModal(false)}
//           >
//             <div
//               style={{
//                 backgroundColor: 'white',
//                 padding: '20px',
//                 borderRadius: '8px',
//                 maxWidth: '900px',
//                 width: '90%',
//                 maxHeight: '100vh',
//                 overflowY: 'auto'
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                 <h3></h3>
//                 <button
//                   onClick={() => setShowAddModal(false)}
//                   style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
//                 >
//                   ×
//                 </button>
//               </div>

//               {/* Replace YourNewComponent with your actual component */}
//               <SustainabilityDeclarationForm
//                 onClose={() => setShowAddModal(false)}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </KTCard>
//   )
// }

// export { IsccWasteCollectorPaymentList }

















import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider, useQueryRequest } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard, initialQueryState } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { roleColumns } from './_columns'
// import { roleColumns } from './_columnsC'
import { roleColumns } from './_columnsIn'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../core/_requests'
import { useAuth } from '../../../../auth'

const UsersList = () => {
  const { auth, isSupplyChainManager, currentUser } = useAuth()
  console.log("curr is", currentUser)
  const hideDropdown = auth?.data?.userType === 'SMART_CENTRE' || false
  const { data } = useQuery(
    `users?page=0&size=10&type=FRANCHISE`,
    () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
    {
      enabled: hideDropdown,
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )






  const [searchQuery, setSearchQuery] = useState('')
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase()
    setSearchQuery(query)

    // Get all table rows
    const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

    // Loop through each row
    tableRows.forEach((row: HTMLTableRowElement) => {
      const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
      let found = false

      // Check each cell in the row
      cells.forEach((cell: HTMLTableCellElement) => {
        const text = cell.textContent?.toLowerCase() || ''
        if (text.includes(query)) {
          found = true
        }
      })

      // Show/hide row based on search match
      if (found) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }




  // const getInitialApi = () => {
  //   if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
  //     return 'collect/orders?page=0&size=10&wasteSource=C2B'
  //   }
  //   return 'collect/orders'
  // }


  const getInitialApi = () => {
    if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
      return 'collect/orders?wasteSource=C2B'  // Keep this as is
    }
    return 'collect/orders'
  }


  const { updateState } = useQueryRequest()
  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
  useEffect(() => {
    if (data && data.length) {
      let dropdownData: any = [{ label: 'Select one', value: '' }]
      data.map((eachData) => {
        return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0]?.value}/items`,
        ...initialQueryState,
      })
    }
  }, [data])
  const searchElements = [
    {
      type: 'datePicker',
      name: 'start_date',
      label: 'Start date',
    },
    {
      type: 'datePicker',
      name: 'end_date',
      label: 'End date',
    },

    {
      ...(hideDropdown && {
        type: 'select',
        value: 'select',
        options: categoriesList,
        name: 'franchiseeid',
        label: 'Franchise',
      }),
    },
  ]
  const { itemIdForUpdate } = useListView()
  return (
    <KTCard>
      {/* <UsersListHeader
        showDownload
        showResetButton={true}
        initialApi='collect/orders'
        searchElements={searchElements}
        placeholder='Search Category'
      />
      <UsersTable
        initialApi='collect/orders'
        showPagination={true}
        columnProps={roleColumns(isSupplyChainManager)}
      /> */}
      {/* <UsersListHeader
        showDownload
        showResetButton={true}
        initialApi={getInitialApi()}  // Use the same function
        searchElements={searchElements}
        placeholder='Search Category'
      /> */}







      <div
        style={{
          position: 'relative',
          width: '300px',
          marginLeft: '30px',
          marginTop: '25px',
          // marginBottom: '-30px',
        }}
      >
        <SearchIcon />
        <input
          type='text'
          placeholder='Search record...'
          value={searchQuery}
          onChange={handleSearch}
          style={{
            width: '100%',
            height: '40px',
            padding: '8px 8px 8px 35px',
            fontSize: '14px',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            outline: 'none',
            backgroundColor: 'white',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
          onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
        />
      </div>



      <UsersTable
        initialApi={getInitialApi()}  // Use the same function
        showPagination={true}
        columnProps={roleColumns(isSupplyChainManager)}
      />
      <UserEditModal
        // getByIdApi='collect/orders/'
        showViewPage={itemIdForUpdate?.showCertificate ? true : false}
        formName='IsccuViewImageForm'
      />
    </KTCard>
  )
}

// const CollectOrdersWrapper = () => (
//   <QueryRequestProvider initialValue={{ initialApi: 'collect/orders' }}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <UsersList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )



const SearchIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    style={{
      position: 'absolute',
      left: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#6B7280',
    }}
  >
    <circle cx='11' cy='11' r='8' />
    <line x1='21' y1='21' x2='16.65' y2='16.65' />
  </svg>
)

const IsccWasteCollectorPaymentList = () => {
  const { auth } = useAuth()

  const getInitialApi = () => {
    if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
      return 'return/orders?status=COMPLETED&isBatchConsumed=false'
    }
    return 'collect/orders'
  }

  return (
    <QueryRequestProvider initialValue={{ initialApi: getInitialApi(), size: 50 }}>
      <QueryResponseProvider>
        <ListViewProvider>
          <UsersList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { IsccWasteCollectorPaymentList }





